var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.size == 'large' ? 'large-box' : ''},[_c('commonHeader',{attrs:{"activityFrom":_vm.activityFrom}}),_c('div',{staticClass:"center-box",class:_vm.size == 'large' ? 'large' : ''},[_vm._t("default")],2),_c('commonFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }